import * as yup from 'yup';

import { yupGermanNumberTransform } from '@/utils/numberParser';
import { CreateOperatingCostInvoiceLineItemV1Dto } from '@/openapi/models/CreateOperatingCostInvoiceLineItemV1Dto';

export const getOperatingCostInvoiceLineSchema = (t: (key: string) => string) =>
  yup.object({
    areaDesignation: yup.string().required(t('errors.required')),
    nameOnStatement: yup.string().required(t('errors.required')),
    sfmPositionId: yup.string().required(t('errors.required')),
    status: yup.string().required(t('errors.required')),
    isFlatRate: yup.boolean().required(t('errors.required')),
    totalAmount: yup.number().transform(yupGermanNumberTransform).optional().nullable(),
    customerAmount: yup.number().transform(yupGermanNumberTransform).optional().nullable(),
    totalArea: yup.number().transform(yupGermanNumberTransform).optional().nullable(),
    customerArea: yup.number().transform(yupGermanNumberTransform).optional().nullable(),
    unit: yup.string().optional().nullable(),
  });

export const UNIT_SUFFIXES: Record<CreateOperatingCostInvoiceLineItemV1Dto.unit, string> = {
  [CreateOperatingCostInvoiceLineItemV1Dto.unit.SQUARE_METER]: ' m²',
  [CreateOperatingCostInvoiceLineItemV1Dto.unit.CUBIC_METER]: ' m³',
  [CreateOperatingCostInvoiceLineItemV1Dto.unit.KILOWATT_HOURS]: ' kWh',
  [CreateOperatingCostInvoiceLineItemV1Dto.unit.PIECE]: ' Piece',
  [CreateOperatingCostInvoiceLineItemV1Dto.unit.DEGREE_DAYS]: ' Kd',
  [CreateOperatingCostInvoiceLineItemV1Dto.unit.PERCENT]: ' %',
  [CreateOperatingCostInvoiceLineItemV1Dto.unit.KILOGRAM]: ' kg',
  [CreateOperatingCostInvoiceLineItemV1Dto.unit.HOURS]: ' h',
};
